import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FilterDTO, FilterOperator, ParkingSubscriptionClient, ParkingSubscriptionDTO, ParkingSubscriptionType, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { DropDownConstantsFactory, StandardDropdownItem } from 'src/app/base/shared/syncfusion/dropdown-constants-factory';
import { ReplaceSubscriptionFormGroup } from './parker-function-replace-subscription-form.type';
import { CustomValidatorsFactory } from 'src/app/base/shared/validators/custom-validators-factory';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NgClass } from '@angular/common';
import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';

@Component({
    selector: 'app-parker-function-replace-subscription-form',
    templateUrl: './parker-function-replace-subscription-form.component.html',
    styleUrls: ['./parker-function-replace-subscription-form.component.scss'],
    imports: [ReactiveFormsModule, DropDownListModule, AppErrorMessagesComponent, CheckBoxModule, YesNoGroupButtonComponent, FormsModule, NgClass, DateTimePickerModule, TranslateModule]
})
export class ParkerFunctionReplaceSubscriptionFormComponent implements OnInit {
  @Input() public parkerSubscriptionForm: ReplaceSubscriptionFormGroup;
  @Input() public clientId: number;

  public dropdownSettings = DropDownConstantsFactory.createStandardClientDropdownSettings();
  public oldSubscriptionsDropdownValues: StandardDropdownItem[] = [];
  public newSubscriptionsDropdownValues: StandardDropdownItem[] = [];
  public isFromDateImmediate = false;
  public isToDateImmediate = false;

  public allSubscriptions: ParkingSubscriptionDTO[] = [];
  constructor(private parkingSubscriptionClient: ParkingSubscriptionClient) {
  }

  ngOnInit() {
    this.isFromDateImmediate = this.parkerSubscriptionForm.value.validFrom === null;
    this.handleDateField(this.isFromDateImmediate, this.parkerSubscriptionForm.controls.validFrom);
    this.isToDateImmediate = this.parkerSubscriptionForm.value.validTo === null;
    this.handleDateField(this.isToDateImmediate, this.parkerSubscriptionForm.controls.validTo, this.parkerSubscriptionForm.controls.validFrom);

    this.parkerSubscriptionForm.controls.validFrom.valueChanges.subscribe((value) => {
      this.parkerSubscriptionForm.controls.validTo?.updateValueAndValidity();
    });

    const filters = [
      new FilterDTO({
        isComplex: false,
        field: 'Active',
        operator: FilterOperator.Equal,
        value: 'true'
      }),
      new FilterDTO({
        isComplex: false,
        field: 'Type',
        operator: FilterOperator.NotEqual,
        value: ParkingSubscriptionType.ForeignParkerSubscription.toString()
      })
    ];

    this.parkingSubscriptionClient.searchParkingSubscriptions(this.clientId, filters, 0, 0, 'Name', SortDirection.Ascending)
      .subscribe(res => {
        this.allSubscriptions = res.items;
        this.oldSubscriptionsDropdownValues = [];
        this.newSubscriptionsDropdownValues = [];
        this.allSubscriptions?.forEach(s => {
          let label = s.name;
          if (s.description) {
            label += ', ' + s.description;
          }

          this.oldSubscriptionsDropdownValues.push({ name: label, id: s.id });
          if (s.assignable) {
            this.newSubscriptionsDropdownValues.push({ name: label, id: s.id });
          }
        });
      });
  }

  public handleDateField(isDateImmediate: boolean, control: AbstractControl, refControl: AbstractControl = null): void {
    if (isDateImmediate) {
      control?.disable();
      control?.setValue(null, { emitEvent: false });
      control?.setValidators([]);
    } else {
      control?.enable();
      control?.setValidators([Validators.required]);
      if (refControl) {
        control?.setValidators([Validators.required, CustomValidatorsFactory.validateDateNotBeforeDate(this.parkerSubscriptionForm.controls.validFrom)]);
      }
    }

    control?.updateValueAndValidity();
  }

  public fromDateImmediateChanged(): void {
    this.handleDateField(this.isFromDateImmediate, this.parkerSubscriptionForm.controls.validFrom);
    this.handleDateField(this.isToDateImmediate, this.parkerSubscriptionForm.controls.validTo, this.parkerSubscriptionForm.controls.validFrom);
  }
}
